module.exports = __webpack_public_path__ + "img/staple-food.c96c6e25.svg";